<ag-grid-angular
  #agGridCasualReport
  style='width: 100%'
  [style.height]='otherOptions.reportHeight'
  class='ag-theme-balham'
  [rowData]='rawData'
  [columnDefs]='columnsToDisplay'
  [enableRtl]='isRtlLanguage'
  [gridOptions]='gridOptions'
  (gridReady)='agGridReady()'
  (cellDoubleClicked)='cellDoubleClicked($event)'
  (selectionChanged)='getRowSelection($event)'
  (sortChanged)='gridSortChanged()'
  [components]='customComponents'
>
</ag-grid-angular>
